import request from '@/utils/request';

//获取函数查询的资源
export function getfunctionResource(data) {
  return request.post('admin/group-function/resource', data);
}

//获取函数列表
export function getfunctionList(data) {
  return request.post('admin/group-function/list', data);
}

//新增函数
export function newStoreFunction(data) {
  return request.post('admin/group-function/store', data);
}
//获取函数详情
export function getFunctionDetail(data) {
  return request.post('/admin/group-function/detail', data);
}

//编辑函数
export function editFunction(data) {
  return request.post('admin/group-function/edit', data);
}
//修改函数状态
export function changeFunctionStatus(data) {
  return request.post('/admin/group-function/status', data);
}